"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const entity_1 = require("../../type/entity");
const assignmentCardZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/assignmentCardZeroState"));
const assignmentQuestionZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/assignmentQuestionZeroState"));
const cardQuestionForReviewZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/cardQuestionForReviewZeroState"));
const learningCardZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/learningCardZeroState"));
const peerReviewCardZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/peerReviewCardZeroState"));
const sectionZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/sectionZeroState"));
const isEmptyObject = (obj) => Object.keys(obj).length === 0 && obj.constructor === Object;
function createNonExistingStatesUnderOffer(content, user, statesByContentId, newStates) {
    for (const child of content.children || []) {
        createNonExistingStatesUnderOffer(child, user, statesByContentId, newStates);
    }
    const contentType = content.offerType;
    if (!statesByContentId[content._id]) {
        let state = {};
        switch (contentType) {
            case entity_1.ContentType.LEARNING_CARD:
                state = learningCardZeroState_1.default(content, user);
                break;
            case entity_1.ContentType.ASSIGNMENT_CARD:
                state = assignmentCardZeroState_1.default(content, user);
                break;
            case entity_1.ContentType.CARD_QUESTION:
                state = assignmentQuestionZeroState_1.default(content, user);
                break;
            case entity_1.ContentType.PEER_REVIEW_CARD:
                state = peerReviewCardZeroState_1.default(content, user);
                break;
            case entity_1.ContentType.CARD_QUESTION_FOR_REVIEW:
                state = cardQuestionForReviewZeroState_1.default(content, user);
                break;
            case entity_1.ContentType.SECTION:
                state = sectionZeroState_1.default(content, user);
                break;
            default:
                break;
        }
        if (!isEmptyObject(state)) {
            newStates.push(state);
        }
    }
}
exports.createNonExistingStatesUnderOffer = createNonExistingStatesUnderOffer;
//# sourceMappingURL=createNonExistingStatesUnderOffer.js.map